import { SizeByKey } from '@/ts/composables/useSizeBy';

interface SizeByOption {
  name: string;
  key: SizeByKey;
}

const SIZE_BY_OPTIONS: SizeByOption[] = [
  { name: 'Market Cap', key: 'market-cap-adjusted' },
  { name: 'Equal Weight', key: 'equal-weight' },
  { name: 'Price', key: 'price' },
];

export {
  SIZE_BY_OPTIONS
}

